import { cn } from '@/lib/utils'
import { ReactNode } from 'react'

interface SectionProps {
	id?: string
	children: ReactNode
	className?: string
}

export function Section({ id, children, className }: SectionProps) {
	return (
		<section
			id={id}
			className={cn('py-8', className)}
		>
			{children}
		</section>
	)
}

interface SubSectionProps {
	id?: string
	children: ReactNode
	className?: string
	showSeparator?: boolean
}

export function SubSection({ id, children, className, showSeparator = true }: SubSectionProps) {
	return (
		<div id={id} className={cn('py-6', className)}>
			{showSeparator && (
				<div className="border-t border-[#3A2E2F]/20 mx-8 mb-6" />
			)}
			{children}
		</div>
	)
}

interface SectionHeadingProps {
	children: ReactNode
	className?: string
	level?: 'h2' | 'h3'
}

export function SectionHeading({ children, className, level = 'h3' }: SectionHeadingProps) {
	const Component = level
	const baseClass = level === 'h2' 
		? 'text-xl font-semibold tracking-tight mb-4'
		: 'text-lg font-semibold mb-4'
	
	return (
		<Component className={cn(baseClass, className)}>
			{children}
		</Component>
	)
}
